export default "<span>&copy; {{settings.app.year}} - {{ settings.app.name }}</span>";